
    import process from 'process';
    import { Buffer } from 'buffer';

    function applyAssets(bucketOk) {
      if (bucketOk) {
        document.getElementById('favicon').setAttribute('href', `${bucketurl}/watermarked/favicon.ico`);
        document.getElementById('apple-touch-icon').setAttribute('href', `${bucketurl}/watermarked/logo192.png`);
        document.documentElement.style.setProperty("--watermarked-logo-url", `url(${bucketurl}/watermarked/logo.svg)`);
        document.documentElement.style.setProperty("--watermarked-logo-small-url", `url(${bucketurl}/watermarked/logo_small.svg)`);
      } else {
        document.getElementById('favicon').setAttribute('href', `/watermarked/favicon.ico`);
        document.getElementById('apple-touch-icon').setAttribute('href', `/watermarked/logo192.png`);
        document.documentElement.style.setProperty("--watermarked-logo-url", `url(/watermarked/logo.svg)`);
        document.documentElement.style.setProperty("--watermarked-logo-small-url", `url(/watermarked/logo_small.svg)`);
      }
    }
    window.process = process;
    window.Buffer = Buffer;
    const bucketurl = window.frontendENV?.WATERMARKED_BUCKET || '';

    if (window.frontendENV?.WATERMARKED_BUCKET) {
      const testUrl = bucketurl + '/watermarked/logo192.png';
      fetch(testUrl)
        .then(response => {
          const bucketOk = response.ok;
          applyAssets(bucketOk);
        })
        .catch(() => {
          applyAssets(false);
        });
    } else {
      applyAssets(false);
    }


  